"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createZakatPayment = exports.getZakatPortfolio = exports.deleteZakatLiability = exports.updateZakatLiability = exports.createZakatLiability = exports.deleteZakatAsset = exports.updateZakatAsset = exports.createZakatAsset = exports.updateZakat = exports.getNisab = exports.getZakat = void 0;
const getZakat = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/zakat`, {
  withCredentials: true
});
exports.getZakat = getZakat;
const getNisab = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/zakat/nisab`, {
  withCredentials: true
});
exports.getNisab = getNisab;
const updateZakat = (serverURL, appAxios) => async data => await appAxios.put(`${serverURL}/zakat`, data, {
  withCredentials: true
});
exports.updateZakat = updateZakat;
const createZakatAsset = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/zakat/assets`, data, {
  withCredentials: true
});
exports.createZakatAsset = createZakatAsset;
const updateZakatAsset = (serverURL, appAxios) => async (assetId, data) => await appAxios.put(`${serverURL}/zakat/assets/${assetId}`, data, {
  withCredentials: true
});
exports.updateZakatAsset = updateZakatAsset;
const deleteZakatAsset = (serverURL, appAxios) => async assetId => await appAxios.delete(`${serverURL}/zakat/assets/${assetId}`, {
  withCredentials: true
});
exports.deleteZakatAsset = deleteZakatAsset;
const createZakatLiability = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/zakat/liabilities`, data, {
  withCredentials: true
});
exports.createZakatLiability = createZakatLiability;
const updateZakatLiability = (serverURL, appAxios) => async (liabilityId, data) => await appAxios.put(`${serverURL}/zakat/liabilities/${liabilityId}`, data, {
  withCredentials: true
});
exports.updateZakatLiability = updateZakatLiability;
const deleteZakatLiability = (serverURL, appAxios) => async liabilityId => await appAxios.delete(`${serverURL}/zakat/liabilities/${liabilityId}`, {
  withCredentials: true
});
exports.deleteZakatLiability = deleteZakatLiability;
const getZakatPortfolio = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/zakat/portfolio`, {
  withCredentials: true
});
exports.getZakatPortfolio = getZakatPortfolio;
const createZakatPayment = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/payments/zakat`, data, {
  withCredentials: true
});
exports.createZakatPayment = createZakatPayment;